<template>
    <div>
        <div class="object-titlebox">
            <div class="object-titlebox-left">
                {{ $t('message.title_app_control') }}
            </div>
        </div>
        <div class="object-inner-table">
            <div class="default-message" style="margin:12px 0px">
                <span v-html="$t('message.info_app_control_guide')"></span>
                <br><br>
                <span style="color:#d55169" v-html="$t('message.caution_app_control_guide_need_client_version')"></span>
            </div>

            <div class="object-titlebox" style="height: 40px"></div>

            <div class="default-message" style="margin:12px 0px">
                <span v-t="'message.item_app_control_label1'"></span>
                <button :class="{
                    'transparent-button': enableCheck,
                    'transparent-button-disabled': !enableCheck
                }" type="button" @click="handleConnStatusCheck()">
                    <img style="height:16px" src="@/assets/icon_load.svg" />
                </button>
            </div>

            <div class="default-message" style="margin:12px 0px">
                <p> {{ onlineUserNum }} </p>
            </div>

            <div class="default-message" style="margin:12px 0px">
                <el-button :class="{
                    'dangerous-enable-command-button': enableTermination,
                    'dangerous-disable-command-button': !enableTermination
                }" :disabled="!enableTermination" @click="showConfirmDialog('termination')"
                    v-t="'message.button_app_control_termination'">
                </el-button>
                <el-button :class="{
                    'enable-command-button': enableLaunch,
                    'disable-command-button': !enableLaunch
                }" :disabled="!enableLaunch" @click="showConfirmDialog('launch')"
                    v-t="'message.button_app_control_launch'">
                </el-button>
            </div>
        </div>
        <ConfirmDialog v-if="showDialog" :dialogData="dialogData" @termination="handleTermination"
            @launch="handleLaunch" @cancel="showDialog = false">
        </ConfirmDialog>
    </div>
</template>

<script>
import server from "@/components/ServerApi.js";
import commonUtil from '@/components/commonutil.js';
import constants from '@/components/constants.js';
import ConfirmDialog from "@/components/pc/setting/appcontrol/ConfirmDialog";

const RequestType = Object.freeze({
    CONN_STATUS_CHECK: 0,
    TERMINATION: 1,
    LAUNCH: 2
});

const CHECK_BUTTON_DISABLE_TIME = 10 * 1000; // 10s
const BUTTON_DISABLE_TIME = 60 * 1000; // 60s

export default {
    components: {
        ConfirmDialog: ConfirmDialog,
    },
    data() {
        return {
            onlineUserNum: "-",
            isCheck: false,
            isTermination: false,
            isLaunch: false,
            connStatusCheckTimerId: null,
            showDialog: false,
            dialogData: {
                action: "",
                emit: "",
            },
        };
    },
    computed: {
        enableCheck() {
            return !this.isCheck;
        },
        enableTermination() {
            return !this.isTermination;
        },
        enableLaunch() {
            return !this.isLaunch;
        },
    },
    methods: {
        async request(requestType, msgOutput = true) {
            const payload = { requestType };
            try {
                const res = await server.post("/applicationcontrol", payload);
                switch (res.data.status) {
                    case constants.STATUS_SUCCESS:
                        break;
                    case constants.STATUS_ERROR_NOT_FOUND:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "warn_app_control_not_found").replace("{buttonName}", this.getButtonName(requestType)))
                        break;
                    case constants.STATUS_ERROR_TALKGROUP_NOT_FOUND:
                        msgOutput && commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "warn_app_control_not_talkgroup_yet"))
                        break;
                    case constants.STATUS_ERROR_PERMISSION_DENIED:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_need_tenant_admin_privilege"));
                        break;
                    case constants.STATUS_ERROR_TOO_MANY_REQUEST:
                        commonUtil.notifyMessage(this, "Warning", commonUtil.getMessageText(this.$i18n, "warn_app_control_too_many_request")
                            .replace("{buttonName}", this.getButtonName(requestType)));
                        break;
                    default:
                        commonUtil.notifyMessage(this, "Error", commonUtil.getMessageText(this.$i18n, "error_server_api").replace("{functionName}", "request").replace("{code}", res.data.status));
                        break;
                }
                return res.data;
            } catch (error) {
                commonUtil.putExceptionErrorMessage(this, "request", error);
                return { status: constants.STATUS_ERROR_UNKNOWN };
            }

        },
        async handleConnStatusCheck(msgOutput = true) {
            this.isCheck = true;
            const { status, onlineUserNum } = await this.request(RequestType.CONN_STATUS_CHECK, msgOutput);
            switch (status) {
                case constants.STATUS_SUCCESS:
                case constants.STATUS_ERROR_TALKGROUP_NOT_FOUND:
                    this.onlineUserNum = onlineUserNum;
                    setTimeout(() => {
                        this.isCheck = false;
                    }, CHECK_BUTTON_DISABLE_TIME);
                    break;
                default:
                    this.onlineUserNum = "error";
                    this.isCheck = false;
                    break;
            }
        },
        async handleTermination() {
            this.showDialog = false;
            this.isTermination = true;
            const { status } = await this.request(RequestType.TERMINATION);
            if (status === constants.STATUS_SUCCESS) {
                commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_app_control_termination"));
                setTimeout(() => {
                    this.isTermination = false;
                }, BUTTON_DISABLE_TIME);
            } else {
                this.isTermination = false;
            }
        },
        async handleLaunch() {
            this.showDialog = false;
            this.isLaunch = true;
            const { status } = await this.request(RequestType.LAUNCH);
            if (status === constants.STATUS_SUCCESS) {
                commonUtil.notifyMessage(this, "Success", commonUtil.getMessageText(this.$i18n, "info_app_control_launch"));
                setTimeout(() => {
                    this.isLaunch = false;
                }, BUTTON_DISABLE_TIME);
            } else {
                this.isLaunch = false;
            }
        },
        getButtonName(requestType) {
            switch (requestType) {
                case RequestType.TERMINATION:
                    return commonUtil.getMessageText(this.$i18n, "button_app_control_termination");
                case RequestType.LAUNCH:
                    return commonUtil.getMessageText(this.$i18n, "button_app_control_launch");
            }
        },
        showConfirmDialog(actionName) {
            this.dialogData.action = actionName; // "termination" or "launch"
            this.dialogData.emit = actionName;
            this.showDialog = true;
        },
    },
}
</script>

<style scoped>
.table-column {
    background-color: #f6f6f6;
    color: #848991;
}

.table-column {
    background-color: #f6f6f6;
    color: #848991;
}

.object-item1 {
    padding-top: 10px;
    padding-bottom: 10px;
    padding-left: 28px;
    font-size: 14px;
}

.el-button.dangerous-enable-command-button {
    font-size: 14px;
    padding: 10px 30px;
    padding-left: 10px;
    padding-right: 16px;
    color: #ffffff;
    position: relative;
    display: inline-block;
    background-color: #d55169;
    cursor: pointer;
}

.el-button.dangerous-enable-command-button:hover,
.el-button.dangerous-enable-command-button:active,
.el-button.dangerous-enable-command-button:focus {
    color: #ffffff;
    background-color: #d55169;
    border-color: #d55169;
    opacity: 0.8;
}

.el-button.dangerous-disable-command-button {
    font-size: 14px;
    padding: 10px 30px;
    padding-left: 10px;
    padding-right: 16px;
    color: #ffffff;
    position: relative;
    display: inline-block;
    background-color: #d55169;
    cursor: not-allowed;
}

.el-button.dangerous-disable-command-button,
.el-button.dangerous-disable-command-button,
.el-button.dangerous-disable-command-button {
    color: #ffffff;
    background-color: #d55169;
    opacity: 0.3;
}

.el-button.dangerous-disable-command-button:hover,
.el-button.dangerous-disable-command-button:active,
.el-button.dangerous-disable-command-button:focus {
    color: #ffffff;
    background-color: #d55169;
    opacity: 0.3;
}
</style>
